import { useRef } from 'react';

export function useFocus() {
  const ref = useRef(null);

  const setFocus = (): void => {
    setTimeout(() => {
      // @ts-ignore
      ref.current?.focus();
    }, 100);
  };

  return [ref, setFocus];
}
